import e from"../../metadata.min.json.js";function o(a,r){var t=Array.prototype.slice.call(r);return t.push(e),a.apply(this,t)}export{o as default};
